import { useState } from 'react';

export function CornerPieceCard({ piece, cornerData, onClick, index, isLocked, isCompleted, isStudied }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button onClick={onClick} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      data-testid={`corner-piece-${piece.order}`}
      className="group relative text-left w-full rounded-xl overflow-hidden transition-all duration-500"
      style={{ animation: `fade-up 0.6s ease-out ${index * 0.1}s both`, transform: hovered ? 'scale(1.02)' : 'scale(1)', opacity: isLocked ? 0.5 : 1,
        boxShadow: hovered ? '0 0 40px rgba(30,58,95,0.2), 0 15px 50px rgba(0,0,0,0.5)' : '0 4px 30px rgba(0,0,0,0.4)' }}>
      <div className="p-5 sm:p-6 border rounded-xl transition-all duration-500"
        style={{ background: 'linear-gradient(135deg, #0d0f14 0%, #0a0805 50%, #0d0a06 100%)', borderColor: isCompleted ? 'rgba(16,185,129,0.3)' : hovered ? 'rgba(30,58,95,0.5)' : 'rgba(30,58,95,0.15)' }}>
        {/* Corner number */}
        <div className="flex items-center justify-between mb-4">
          <span className="text-[10px] tracking-[0.3em] uppercase font-bold" style={{ color: '#dc2626' }}>
            Corner Piece #{piece.order}
          </span>
          {isLocked && (
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] tracking-wider" style={{ background: 'rgba(100,116,139,0.15)', color: 'rgba(148,163,184,0.7)', border: '1px solid rgba(100,116,139,0.2)' }}>
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
              LOCKED
            </span>
          )}
          {isCompleted && (
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] tracking-wider" style={{ background: 'rgba(16,185,129,0.1)', color: 'rgba(52,211,153,0.8)', border: '1px solid rgba(16,185,129,0.2)' }}>
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
              MASTERED
            </span>
          )}
        </div>
        {/* Scripture reference */}
        <p className="text-xs mb-2" style={{ color: '#c4a265' }}>{cornerData.ref}</p>
        {/* Anchor phrase */}
        <p className="text-lg font-bold mb-3 leading-snug" style={{ color: isLocked ? 'rgba(212,165,74,0.25)' : '#d4a54a' }}>
          "{cornerData.anchor}"
        </p>
        {/* Question */}
        <p className="text-sm leading-relaxed mb-3" style={{ color: isLocked ? 'rgba(220,190,130,0.15)' : 'rgba(220,190,130,0.6)' }}>
          {cornerData.question}
        </p>
        {/* Rules out */}
        <div className="rounded-lg px-3 py-2" style={{ background: 'rgba(220,38,38,0.04)', border: '1px solid rgba(220,38,38,0.1)' }}>
          <p className="text-xs" style={{ color: isLocked ? 'rgba(220,38,38,0.15)' : 'rgba(220,38,38,0.6)' }}>
            <span className="font-bold uppercase tracking-wider" style={{ fontSize: '9px' }}>Rules out: </span>
            {cornerData.rulesOut}
          </p>
        </div>
        {/* CTA */}
        {isLocked && (
          <div className="mt-4 flex items-center gap-2 px-3 py-2 rounded-lg text-xs" style={{ background: 'rgba(212,165,74,0.06)', border: '1px solid rgba(212,165,74,0.15)', color: '#d4a54a' }}
            data-testid={`corner-locked-msg-${piece.order}`}>
            <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
            <span>Complete all 3 Legend Keys below to unlock this corner piece</span>
          </div>
        )}
        {!isLocked && (
          <div className="mt-4 flex items-center gap-1.5 text-[10px] tracking-wider uppercase opacity-0 group-hover:opacity-100 transition-all duration-300" style={{ color: isCompleted ? '#34d399' : '#d4a54a' }}>
            <span>{isCompleted ? 'Review this corner piece' : 'Open this corner piece'}</span>
            <svg className="w-3 h-3 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
          </div>
        )}
      </div>
    </button>
  );
}
